module.exports = __webpack_public_path__ + "static/media/ramen@2x.4a354be0.png";